import api from 'config/axios';
import AppService from 'common/app-service';

export interface IFile {
  id: number;
  name: string;
  size?: number;
  submittedBy?: string;
  group?: string;
  baseDate: string;
  createdAt: string;
}

export interface GroupFileItem {
  id: string;
  files: IFile[];
}

export default class FilesService extends AppService {
  constructor() {
    super('files', api);
  }

  async upload(formData: FormData) {
    const response = await this.api.post(this.root('upload'), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  async publicUpload(formData: FormData) {
    const response = await this.api.post(this.root('public-upload'), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  async getGroupedFiles(carrierBranchId: number): Promise<GroupFileItem[]> {
    const response = await this.api.get(this.root('grouped'), {
      params: { carrierBranchId },
    });

    return response.data;
  }

  async downloadFile(fileId: string) {
    return this.api.get(this.root(`${fileId}/download`), {
      responseType: 'blob',
    });
  }

  async downloadZip(fileIds: number[]) {
    return this.api.post(this.root('download-zip'), fileIds, {
      responseType: 'blob',
    });
  }

  async deleteMultiple(fileIds: number[]) {
    return this.api.delete(this.root('admin/multiple'), {
      data: { fileIds },
    });
  }
}
